import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useNavigate } from 'react-router-dom';

const ActivityScatterChart = ({ data }) => {
  const navigate = useNavigate();

  const chartOptions = {
    chart: {
      type: 'scatter',
      zoomType: 'xy',
      height: 600,
    },
    title: {
      text: 'Team Activity vs MRR'
    },
    credits:{
        text:''
    },
    xAxis: {
      title: {
        enabled: true,
        text: 'Projects Changed (Last 60 Days)'
      },
      type:'logarithmic',
      plotBands: [{
        from: 0.1, // small offset since log(0) is invalid
        to: 3,
        color: 'rgba(255, 0, 0, 0.05)', // light red tint
        label: {
          text: 'Low Activity Zone',
          style: { color: '#900' }
        }
      }]
    },
    yAxis: {
      title: {
        text: 'MRR ($)'
      },
      max:'auto',
      type:'logarithmic',
      plotBands: [{
        from: 0,
        to: 65,
        color: 'rgba(255, 0, 0, 0.05)',
        label: { 
            text: 'Low MRR', align: 'right',
            style: { color: '#900' } 
        }
      }]
    },
    colors: [
        '#28277E',
        '#6D5BD1',
      ],
    tooltip: {
      formatter: function () {
        return `<b>${this.point.name}</b><br/>
                Activity: ${this.x}<br/>
                MRR: $${this.y}`;
      }
    },
    legend:{
        enabled:false
    },
    plotOptions: {
      series: {
        cursor: 'pointer',
        point: {
          events: {
            click: function () {
              navigate(`/team/${this.team_id}`);
            }
          }
        }
      }
    },
    series: [
      {
        name: 'Teams',
        colorByPoint: false,
        data: data.map(team => ({
          x: team.charts_changed_last_60_days > 0 
          ? team.charts_changed_last_60_days 
          : 0.1,
          y: team.mrr,
          name: team.team_name,
          team_id: team.team_id
        }))
      },
      
    ]
  };

  return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
};

export default ActivityScatterChart;
